import { LOCALENV } from "../../components/common/config/index";

const oneSignalAppIDs = {
  dev: "a2e21464-df38-4a55-a8f8-e8d85acf77d8",
  qa: "1e57f492-624f-4a10-8031-a09a44c25186",
  uat: "f3cda5e0-5f3d-4b18-90cb-9d4eafaf747a",
  prod: "821bd38d-3238-4345-8fc4-c287c88a94e5",
};
const oneSignalAppleAppIDs = {
  dev: "web.onesignal.auto.1947bcbb-3df5-45a5-b464-0be0e15f4a2c",
  qa: "web.onesignal.auto.0f5ba526-5606-4a7b-90fa-69fc66b30a70",
  uat: "web.onesignal.auto.4bf73218-3550-4659-982d-970270d14d2d",
  prod: "web.onesignal.auto.18c6dc90-7633-4ce6-8875-ae2763214094",
};

const env =
  window.location.hostname === "localhost"
    ? LOCALENV
    : process.env.REACT_APP_ENV;

const appID = oneSignalAppIDs[env];

const appleAppID = oneSignalAppleAppIDs[env];

export { appID, appleAppID };
